import React from 'react';
import './DefaultTitle.css';

const DefaultTitle = ({ children }) => {
	return <header className='DefaultTitle text-grey-chalice text-xs font-bold uppercase'><div role='heading' aria-level={2}>{children}</div></header>;
};

export default DefaultTitle;
